import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // 引入路由
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css' // 必须引入样式






const app = createApp(App);

createApp(App)
    .use(router) // 挂载路由
    .use(ElementPlus) // 挂载Element Plus
    .mount('#app')